import CopyIcon from "@components/CopyIcon/CopyIcon";
import { JIDRCurrency } from "@components/CurrencyIcon/CurrencyIcon";
import QRBottomSheet from "@components/QRBottomSheet/QRBottomSheet";
import QRIcon from "@components/QRIcon/QRIcon";
import { toCurrencyFormat, truncateAddress } from "@lib/utils"
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import {
    Container,
    AmountContainer,
    AmountLabel,
    AmountValueContainer,
    AmountValue,
    LinkWrapper,
    LinkText,
    ButtonsContainer,
    CircularButton
} from "./PaymentLinkAmountCard.styles";
import Snackbar from "@components/Snackbar/Snackbar";

const PaymentLinkAmountCard = ({
    amount,
    link
}: {
    amount: number;
    link: string
}) => {
    const { t } = useTranslation();
    return (
        <Container>
            <AmountContainer>
                <AmountLabel>{t('components.paymentLinkAmountCard.amount')}</AmountLabel>
                <AmountValueContainer>
                    <JIDRCurrency />
                    <AmountValue>{toCurrencyFormat(amount)}</AmountValue>
                </AmountValueContainer>
            </AmountContainer>
            <LinkContainer link={link} />
        </Container>
    )
}

export default PaymentLinkAmountCard

const LinkContainer = ({
    link
}: {
    link: string
}) => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false)
    const [showSnackbar, setShowSnackbar] = useState(false)
    const handleSheetOpen = useCallback(() => {
        setOpen(true)
    }, [])
    const handleSheetClose = useCallback(() => {
        setOpen(false)
    }, [])
    return (
        <LinkWrapper>
            <LinkText title={link}> {/* Show full link on hover */}
                {truncateAddress(link, 25, 15)}
            </LinkText>
            <ButtonsContainer>
                <ButtonContainer 
                    onClick={() => { 
                        navigator.clipboard.writeText(link)
                        setShowSnackbar(true) 
                    }}
                >
                    <CopyIcon />
                </ButtonContainer>
                <ButtonContainer onClick={handleSheetOpen}>
                    <QRIcon />
                </ButtonContainer>
            </ButtonsContainer>
            <QRBottomSheet 
                isOpen={open} 
                height="320px"
                onClose={handleSheetClose} 
                qrValue={link}
                qrLabel={t('components.paymentLinkAmountCard.shareToPayerLabel')}
                bottomSheetHeaderTitle={t('components.paymentLinkAmountCard.qrCodeTitle')}
            />
            <Snackbar 
                message={t('components.paymentLinkAmountCard.copiedToClipboard')}
                isVisible={showSnackbar}
                onClose={() => setShowSnackbar(false)}
                duration={2000}
                width="90%"
            />
        </LinkWrapper>
    )
}

const ButtonContainer = ({
    onClick,
    children
}: {
    onClick: (event: React.MouseEvent) => void;
    children: React.ReactNode
}) => {
    return (
        <CircularButton onClick={onClick}>
            {children}
        </CircularButton>
    )
}